import { createAsyncThunk } from '@reduxjs/toolkit'

import { CreateDefectCommentFormData } from '../../../components/create-defect/types'
import { apiPOST } from '../../../lib/api'

type CreateDefectCommentResponse = {
  comment: string
  created: string
  crewType: string
  ownComment: boolean
}

export const createDefectCommentAction = createAsyncThunk<
  CreateDefectCommentResponse,
  CreateDefectCommentFormData,
  { rejectValue: { message: string } }
>('defects/createComment', async (formData, { rejectWithValue }) => {
  try {
    return await apiPOST<CreateDefectCommentResponse>('/defectComment', formData)
  } catch (error: unknown) {
    console.error('Error creating defect comment:', error)
    return rejectWithValue({ message: 'Failed to create defect comment' })
  }
})
